interface DriverPayRateSource<Rate> {
  useVendorRateForDriver?: boolean | null;
  vendorRate?: Rate;
  driverRate?: Rate;
}

export const resolveDriverPayRate = <Rate>({
  useVendorRateForDriver,
  vendorRate,
  driverRate,
}: DriverPayRateSource<Rate>) => (useVendorRateForDriver ? vendorRate : driverRate);
